export function pureStructureFrom(structure) {
    if (!structure) {
        return structure;
    }
    if (structure === Infinity) {
        return Infinity;
    }
    return JSON.parse(JSON.stringify(structure));
}
